var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartHalfFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5617 21.572L17.8058 23.6283C17.4446 23.8977 17.2303 24.3193 17.2261 24.7685C17.222 25.2176 17.4285 25.643 17.7847 25.919L21.8818 29.0943C22.4178 29.5097 23.1743 29.5444 23.7485 29.1786C24.3422 28.8005 24.6024 28.0945 24.4008 27.4405C24.4008 27.4405 23.3667 24.0859 22.8169 22.3027C22.6785 21.8538 22.329 21.5 21.8802 21.3546C21.4313 21.2092 20.9393 21.2903 20.5617 21.572Z",
    fill: "white",
    fillOpacity: 0.24
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2455 1.0975L10.6177 9.79517C10.5822 9.91275 10.464 9.98504 10.3366 9.98475L1.58367 9.96429C0.922582 9.9628 0.337689 10.3701 0.117441 10.9688C-0.10792 11.5816 0.0888831 12.2659 0.616201 12.673L7.87074 18.2733C7.95027 18.3347 7.98837 18.4344 7.95958 18.5284L5.21514 27.478C5.01839 28.1196 5.27231 28.812 5.85157 29.1829C6.41187 29.5418 7.15001 29.5077 7.67302 29.1002C9.93135 27.3407 26.5328 14.4663 28.8557 12.673C29.3831 12.2659 29.5799 11.5816 29.3545 10.9688C29.1343 10.3701 28.5494 9.9628 27.8883 9.96429L19.1354 9.98475C19.008 9.98504 18.8898 9.91275 18.8543 9.79517C18.3735 8.20379 17.1004 3.99012 16.2265 1.0975C16.0332 0.457856 15.4293 0.00939941 14.736 0.00939941C14.0427 0.00939941 13.4388 0.457856 13.2455 1.0975Z",
    fill: "url(#paint0_linear_5360_10900)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5360_10900",
    x1: 0.426836,
    y1: 11.2287,
    x2: 29.848,
    y2: 11.6373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.489035,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.571998,
    stopColor: "white",
    stopOpacity: 0.24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartHalfFill);
export default __webpack_public_path__ + "static/media/start-halfFill.fbc5462a9e42b8585f7dfb8ec4731c58.svg";
export { ForwardRef as ReactComponent };